<script setup lang="ts">
/**
 * 根组件
 *
 * 只做一件事：渲染当前路由。
 * 布局（侧栏、顶栏）放在 ConsoleLayout 里，登录页不需要它。
 */
</script>

<template>
  <router-view />
</template>
